import styled from '@emotion/styled';
import { Colors } from 'styles/variables/colors';
import { TextStyle } from 'styles/variables/mixins';
import { css } from '@emotion/react';

export const SelectorParentDiv = styled.div<{ isHidden: boolean }>`
    display: ${({ isHidden }) => (isHidden ? 'none' : 'flex')};
    justify-content: center;
    align-items: center;
`;

export const SelectionContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px;
    gap: 10px;
    width: fit-content;
    height: 50px;
    border: 1px solid #bcc1ca;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 20px;
`;

export const SelectorItem = styled.button<{ isActive: boolean }>`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 5px;
    border-radius: 20px;
    line-height: 1;
    ${TextStyle({ fontSize: '15px', fontWeight: '600', color: Colors.revampedPurple })};

    ${({ isActive }) =>
        isActive &&
        css`
            background: ${Colors.revampedPurple};
            padding: 10px 20px;
            border: 1px solid #9095a0;
            box-shadow: 0px 2px 20px rgba(96, 37, 216, 0.2);
            color: ${Colors.white};
        `}
`;
